import React from 'react';
import {executeQuery} from "../../requests/executeQuery";
import dollars from "../../dollar-format";
import {HSC_PIPELINE_FEES} from "../../consts/queries";
import {HscPipelineFeesModel, HscPipelineFeesTotals} from "./hscPipelineFeesModel";
import {columns, totalColumns} from "./columns";
import PipelineTable from "../PipelineTable";
import {startYearHscFees} from "../../consts/consts";
import {formatPipelineTitle} from "../../utils";
import hscTeamMembers from '../../hsc-team-members';
import filter from '../../filter';
import Dropdown from '../Dropdown/Dropdown';
import { ApolloConsumer } from '@apollo/client';
import { GET_HSC_PIPELINE_FEES } from '../Graphql/Queries/HscPipelineQuery';
import { fetchData } from '../Service/graphQlService';

export default class HscPipelineFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            loading: false,
            totals: {},
            title: 'Closed',
            teamMembers:'',
            hscquery:{},
            query:{}
        }
		this.client = null;
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    componentDidMount() {
    
        let hscquery={
            HSC_TEAM_MEMBERS:''
        };
       this.setState({query:this.props.location.query},()=>{
        if(this.client){
            this.fetch(this.props.routeParams.id);
        }

       })
        let member = this.props.location.query.HSC_TEAM_MEMBERS && this.props.location.query.HSC_TEAM_MEMBERS.split(",") || [];
        const memberList = hscTeamMembers.filter((e)=>{
            return member.indexOf(e.EMAIL)>=0;
        })
        memberList.map((el, index)=>{
            hscquery.HSC_TEAM_MEMBERS += el ? index === hscTeamMembers.length-1 ? el.EMAIL:el.EMAIL+',' : '';
        })
        this.setState({hscquery});   
    }

    handleChangeDropdown(hscquery, optionType, value, valueKey){
        hscquery.HSC_TEAM_MEMBERS = hscquery[valueKey];
        const _query =this.state.query;
        _query.HSC_TEAM_MEMBERS = hscquery[valueKey];
        this.setState({hscquery, query:_query},()=>{
            this.fetch(this.props.routeParams.id);
        })
    }
    // fetch(id) {
    //     this.setState({loading: true});
    //     let teamMembers=[],teamMembersNames=[];
    //     const teamMemberEmails = this.props.location.query.HSC_TEAM_MEMBERS ? this.props.location.query.HSC_TEAM_MEMBERS.split(',') : '';
    //     if(teamMemberEmails)
    //         teamMemberEmails.map((teamMemberEmail) => teamMembers.push(hscTeamMembers.find(el => el.EMAIL === teamMemberEmail)));
    //     teamMembers.map(teamMember => teamMembersNames.push(teamMember.NAME))
    //     let year = id && id.length && id.split('-')[1] !== 'ytd' ? id.split('-')[1] : new Date().getFullYear();
    //     let y = year;
    //     const options = filter(query, 'hscPipelineFees');
    //     // options.param.YEAR = parseInt(options.param.YEAR, 10);
    //     const query = {
    //         STATUS: 'Closed',
    //         YEAR: year,
    //         HSC_TEAM_MEMBERS:this.state.query.HSC_TEAM_MEMBERS ? this.state.query.HSC_TEAM_MEMBERS : '',
    //         order:'LOAN_CLOSING_DATE.asc'
    //     }
    //     const data = this.state.query.HSC_TEAM_MEMBERS ? this.state.query.HSC_TEAM_MEMBERS.split(',') : [];
    //     let yearInt = Number(year);
    //      function getTeamMemberVariables() { 
    //         // Extract first name and last name based on data array
    //         const firstName = data[0] || ""; // First element if available
    //         const lastName = data[1] || "";  // Second element if available
            
    //         // Construct the return object based on available values
    //         if (firstName && lastName) {
    //             return {
    //                 params: {
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt,
    //                     HSC_TEAM_MEMBER_FIRST: firstName,
    //                     HSC_TEAM_MEMBER_LAST: lastName,
    //                 },
    //             }
    //         } else if (firstName) {
    //             return {
    //                params :{  
    //                 STATUS: 'Closed',
    //                 YEAR: yearInt,
    //                 HSC_TEAM_MEMBER_FIRST: firstName}
    //             };
    //         } else if (lastName) {
    //             return {
    //                 params :{
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt,
    //                     HSC_TEAM_MEMBER_LAST: lastName}
    //             };
    //         } else {
    //             return {
    //                 params : {
    //                     STATUS: 'Closed',
    //                 YEAR: yearInt,
    //                 // HSC_TEAM_MEMBER_FIRST: firstName,
    //                 // HSC_TEAM_MEMBER_LAST: lastName,
    //                 }
    //             };
    //         }
    //     }
        
    //     const queryoptions = getTeamMemberVariables();
	// 	const token = localStorage.getItem('authToken');
    //     const requests = [
    //             // this.client.query({
    //             //     query: GET_HSC_PIPELINE_FEES, variables: queryoptions, fetchPolicy: "no-cache",
    //             //     context: {
    //             //         headers: {
    //             //             authorization: `Bearer ${token}`, // Bearer token added here
    //             //         },
    //             //     },
    //             // })

    //           fetchData( GET_HSC_PIPELINE_FEES,  queryoptions)
           

    //         // executeQuery({
    //         //     queryName: HSC_PIPELINE_FEES,
    //         //     options
    //         // }),
    //     ];
    //     while(y > startYearHscFees) {   //old code no need to call already handleing in above code

    //         let q = {
    //             STATUS: 'Closed',
    //             YEAR: --y,
    //             HSC_TEAM_MEMBERS: this.props.location.query.HSC_TEAM_MEMBERS ? this.props.location.query.HSC_TEAM_MEMBERS : '',
    //             order:'LOAN_CLOSING_DATE.asc'
    //         }
    //         let options = filter(q, 'hscPipelineFees');

    //         requests.push(
    //             // this.client.query({
    //             //     query: GET_HSC_PIPELINE_FEES, variables: { params:options.param}, fetchPolicy: "no-cache",
    //             //     context: {
    //             //         headers: {
    //             //             authorization: `Bearer ${token}`, // Bearer token added here
    //             //         },
    //             //     },
    //             // })

    //           fetchData( GET_HSC_PIPELINE_FEES,  { params:options.param})
    //         //     executeQuery({
                
    //         //     queryName: HSC_PIPELINE_FEES,
    //         //     options
    //         // })
    //     );
    //     }

    //     const teamMembersSubtitle = teamMembersNames ? (teamMembersNames.length > 1 ? teamMembersNames[0]+', '+teamMembersNames[1] : teamMembersNames[0]) : null; 
    //     Promise.all(requests).then(res => {
    //         const state = {
    //             loading: false,
    //             title: id ? formatPipelineTitle(id) : "",
    //             rows: [],
    //             totals: [],
    //             teamMembers: teamMembersSubtitle,
    //             length:  res &&  res[0].data.hscPipelineFees.data ? res[0].data.hscPipelineFees.data.length : 0 
    //         };
    //         if (res && res[0].data.hscPipelineFees  && res[0].data.hscPipelineFees.success && Array.isArray(res[0].data.hscPipelineFees.data) && res[0].data.hscPipelineFees.data.length) {
    //             res[0].data.hscPipelineFees.data.map((row, index) => {
    //                 const previousCumulative = index > 0 ? state.rows[index-1].cumulative : 0;
                    
    //                 //both agents selected -> base HSC_LIST_FEE (100%)
    //                 //one agent selected -> compute new HSC_LIST_FEE based on agent percentage
    //                 if(teamMemberEmails && teamMemberEmails.length < 2){
    //                     if(row.HSC_TEAM_MEMBER_1 === teamMemberEmails[0])
    //                         row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT/100;
    //                     else if(row.HSC_TEAM_MEMBER_2 === teamMemberEmails[0])
    //                         row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT/100;
    //                 }

    //                 state.rows.push(new HscPipelineFeesModel({data: row, previousCumulative}));
    //             });
    //             state.rows.push(new HscPipelineFeesModel({data: state.rows, isTotal: true, year}));
    //         }

    //         state.totals.push(new HscPipelineFeesTotals({data: state.rows, year, isCurrentYear: true}));
    //         for (let index = 1; index < res.length; index++) {
    //             if (res[index] && res[index].data){
    //                 let data = res[index].data;
    //                 data.hscPipelineFees.data.map((row, i) => {            
    //                     const previousCumulative = i > 0 ? data.hscPipelineFees.data[i-1].cumulative : 0;

    //                     if(teamMemberEmails && teamMemberEmails.length < 2){
    //                         if(row.HSC_TEAM_MEMBER_1 === teamMemberEmails[0])
    //                             row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT/100;
    //                         else if(row.HSC_TEAM_MEMBER_2 === teamMemberEmails[0])
    //                             row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT/100;
    //                     }
    //                     row.cumulative = row.HSC_LIST_FEE ? parseFloat(row.HSC_LIST_FEE) + previousCumulative : previousCumulative;
    //                 });

    //                 state.totals.push(new HscPipelineFeesTotals({data: data, year: --year}));
    //             }
    //         }
    //         state.totals.push(new HscPipelineFeesTotals({data: state.totals, isTotal: true}));
    //         this.setState(state);
    //     });
    // }
    // fetch(id) {
    //     this.setState({ loading: true });
    
    //     const teamQuery = this.props.location && this.props.location.query && this.props.location.query.HSC_TEAM_MEMBERS;
    //     const teamMembersEmails = teamQuery ? teamQuery.split(',') : [];
    //     const teamMembers = [];
    //     const teamMembersNames = [];
    
    //     for (let i = 0; i < teamMembersEmails.length; i++) {
    //         const member = hscTeamMembers.find(el => el.EMAIL === teamMembersEmails[i]);
    //         if (member) {
    //             teamMembers.push(member);
    //             teamMembersNames.push(member.NAME);
    //         }
    //     }
    
    //     let year = (id && id.length && id.split('-')[1] !== 'ytd') ? id.split('-')[1] : new Date().getFullYear();
    //     let y = year;
    //     const yearInt = parseInt(year, 10);
    
    //     const queryTeam = this.state.query && this.state.query.HSC_TEAM_MEMBERS;
    //     const query = {
    //         STATUS: 'Closed',
    //         YEAR: yearInt,
    //         HSC_TEAM_MEMBERS: queryTeam ? queryTeam : '',
    //         order: 'LOAN_CLOSING_DATE.asc'
    //     };
    
    //     const options = filter(query, 'hscPipelineFees');
    
    //     const data = queryTeam ? queryTeam.split(',') : [];
    //     function getTeamMemberVariables() {
    //         const firstName = data.length > 0 ? data[0] : "";
    //         const lastName = data.length > 1 ? data[1] : "";
    
    //         if (firstName && lastName) {
    //             return {
    //                 params: {
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt,
    //                     HSC_TEAM_MEMBER_FIRST: firstName,
    //                     HSC_TEAM_MEMBER_LAST: lastName
    //                 }
    //             };
    //         } else if (firstName) {
    //             return {
    //                 params: {
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt,
    //                     HSC_TEAM_MEMBER_FIRST: firstName
    //                 }
    //             };
    //         } else if (lastName) {
    //             return {
    //                 params: {
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt,
    //                     HSC_TEAM_MEMBER_LAST: lastName
    //                 }
    //             };
    //         } else {
    //             return {
    //                 params: {
    //                     STATUS: 'Closed',
    //                     YEAR: yearInt
    //                 }
    //             };
    //         }
    //     }
    
    //     const queryoptions = getTeamMemberVariables();
	// 	const token = localStorage.getItem('authToken');
    //     const requests = [
    //             // this.client.query({
    //             //     query: GET_HSC_PIPELINE_FEES, variables: queryoptions, fetchPolicy: "no-cache",
    //             //     context: {
    //             //         headers: {
    //             //             authorization: `Bearer ${token}`, // Bearer token added here
    //             //         },
    //             //     },
    //             // })

    //           fetchData( GET_HSC_PIPELINE_FEES,  queryoptions)
           

    //         // executeQuery({
    //         //     queryName: HSC_PIPELINE_FEES,
    //         //     options
    //         // }),
    //     ];
    //     while(y > startYearHscFees) {   //old code no need to call already handleing in above code

    //         let q = {
    //             STATUS: 'Closed',
    //             YEAR: y,
    //             HSC_TEAM_MEMBERS: teamQuery ? teamQuery : '',
    //             order: 'LOAN_CLOSING_DATE.asc'
    //         };
    //         const oldOptions = filter(q, 'hscPipelineFees');
    //         requests.push(
    //             fetchData(GET_HSC_PIPELINE_FEES, { params: oldOptions.param })
    //         );
    //     }
    
    //     let teamMembersSubtitle = null;
    //     if (teamMembersNames.length > 1) {
    //         teamMembersSubtitle = teamMembersNames[0] + ', ' + teamMembersNames[1];
    //     } else if (teamMembersNames.length === 1) {
    //         teamMembersSubtitle = teamMembersNames[0];
    //     }
    
    //     Promise.all(requests).then(res => {
    //         const state = {
    //             loading: false,
    //             title: id ? formatPipelineTitle(id) : "",
    //             rows: [],
    //             totals: [],
    //             teamMembers: teamMembersSubtitle,
    //             length: 0
    //         };
    
    //         if (
    //             res &&
    //             res[0] &&
    //             res[0].data &&
    //             res[0].data.hscPipelineFees &&
    //             res[0].data.hscPipelineFees.success &&
    //             Array.isArray(res[0].data.hscPipelineFees.data) &&
    //             res[0].data.hscPipelineFees.data.length
    //         ) {
    //             const mainData = res[0].data.hscPipelineFees.data;
    //             state.length = mainData.length;
    
    //             for (let index = 0; index < mainData.length; index++) {
    //                 const row = mainData[index];
    //                 const previousCumulative = index > 0 ? state.rows[index - 1].cumulative : 0;
    
    //                 if (teamMembersEmails.length < 2) {
    //                     if (row.HSC_TEAM_MEMBER_1 === teamMembersEmails[0]) {
    //                         row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT / 100;
    //                     } else if (row.HSC_TEAM_MEMBER_2 === teamMembersEmails[0]) {
    //                         row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT / 100;
    //                     }
    //                 }
    
    //                 state.rows.push(new HscPipelineFeesModel({
    //                     data: row,
    //                     previousCumulative: previousCumulative,
    //                     location: this.props.location
    //                 }));
    //             }
    
    //             state.rows.push(new HscPipelineFeesModel({
    //                 data: state.rows,
    //                 isTotal: true,
    //                 year: year,
    //                 location: this.props.location
    //             }));
    //         }
    
    //         state.totals.push(new HscPipelineFeesTotals({
    //             data: state.rows,
    //             year: year,
    //             isCurrentYear: true,
    //             location: this.props.location
    //         }));
    
    //         for (let i = 1; i < res.length; i++) {
    //             const currentRes = res[i];
    //             if (
    //                 currentRes &&
    //                 currentRes.data &&
    //                 currentRes.data.hscPipelineFees &&
    //                 Array.isArray(currentRes.data.hscPipelineFees.data)
    //             ) {
    //                 const data = currentRes.data.hscPipelineFees.data;
    
    //                 for (let j = 0; j < data.length; j++) {
    //                     const row = data[j];
    //                     const previousCumulative = j > 0 ? data[j - 1].cumulative : 0;
    
    //                     if (teamMembersEmails.length < 2) {
    //                         if (row.HSC_TEAM_MEMBER_1 === teamMembersEmails[0]) {
    //                             row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_1_PERCENT / 100;
    //                         } else if (row.HSC_TEAM_MEMBER_2 === teamMembersEmails[0]) {
    //                             row.HSC_LIST_FEE = row.HSC_LIST_FEE * row.HSC_TEAM_MEMBER_2_PERCENT / 100;
    //                         }
    //                     }
    
    //                     row.cumulative = row.HSC_LIST_FEE
    //                         ? parseFloat(row.HSC_LIST_FEE) + previousCumulative
    //                         : previousCumulative;
    //                 }
    
    //                 year--; // decrease year for each older result
    //                 state.totals.push(new HscPipelineFeesTotals({
    //                     data: data,
    //                     year: year,
    //                     location: this.props.location
    //                 }));
    //             }
    //         }
    
    //         state.totals.push(new HscPipelineFeesTotals({
    //             data: state.totals,
    //             isTotal: true,
    //             location: this.props.location
    //         }));
    
    //         this.setState(state);
    //     });
    // }

    fetch(id) {
        this.setState({ loading: true });
        const teamMembersEmails = this.props.location.query.HSC_TEAM_MEMBERS ? this.props.location.query.HSC_TEAM_MEMBERS.split(',')  : [];
        const teamMembers = teamMembersEmails.map(email => hscTeamMembers.find(el => el.EMAIL === email)).filter(Boolean);
        const teamMembersNames = teamMembers.map(member => member.NAME);
    
        let year = id && id.length && id.split('-')[1] !== 'ytd' ? id.split('-')[1] : new Date().getFullYear();
        let y = year;
        const yearInt = Number(year);
        const token = localStorage.getItem('authToken');
    
        const query = {
            STATUS: 'Closed',
            YEAR: yearInt,
            HSC_TEAM_MEMBERS: this.state.query.HSC_TEAM_MEMBERS || '',
            order: 'LOAN_CLOSING_DATE.asc'
        };
    
        const options = filter(query, 'hscPipelineFees');
    
        const data = (this.state && this.state.query && this.state.query.HSC_TEAM_MEMBERS || '').split(',');

        function getTeamMemberVariables() {
            const [firstName, lastName] = data;
    
            const params = {
                STATUS: 'Closed',
                YEAR: yearInt
            };
    
            if (firstName) params.HSC_TEAM_MEMBER_FIRST = firstName;
            if (lastName) params.HSC_TEAM_MEMBER_LAST = lastName;
    
            return { params };
        }
    
        const queryoptions = getTeamMemberVariables();
        if(id == 'total-closed'){
            delete queryoptions.YEAR;
        }
        const requests = [fetchData(GET_HSC_PIPELINE_FEES, queryoptions)];
    
        while (y > startYearHscFees) {
            const pastYearQuery = {
                STATUS: 'Closed',
                YEAR: --y,
                HSC_TEAM_MEMBERS: this.props.location.query.HSC_TEAM_MEMBERS || '',
                order: 'LOAN_CLOSING_DATE.asc'
            };
            const options = filter(pastYearQuery, 'hscPipelineFees');
            requests.push(fetchData(GET_HSC_PIPELINE_FEES, { params: options.param }));
        }
    
        const teamMembersSubtitle = teamMembersNames.length > 1
            ? `${teamMembersNames[0]}, ${teamMembersNames[1]}`
            : teamMembersNames[0] || null;
    
        Promise.all(requests).then(res => {
            const state = {
                loading: false,
                title: id ? formatPipelineTitle(id) : "",
                rows: [],
                totals: [],
                teamMembers: teamMembersSubtitle,
                length:  res &&  res[0].data && res[0].data.hscPipelineFees.data ? res[0].data.hscPipelineFees.data.length : 0 
            };
    
            if (res && res[0].data.hscPipelineFees  && res[0].data.hscPipelineFees.success && Array.isArray(res[0].data.hscPipelineFees.data) && res[0].data.hscPipelineFees.data.length) {
                res[0].data.hscPipelineFees.data.forEach((row, index) => {
                    const previousCumulative = index > 0 ? state.rows[index - 1].cumulative : 0;
    
                    if (teamMembersEmails.length < 2) {
                        if (row.HSC_TEAM_MEMBER_1 === teamMembersEmails[0])
                            row.HSC_LIST_FEE *= row.HSC_TEAM_MEMBER_1_PERCENT / 100;
                        else if (row.HSC_TEAM_MEMBER_2 === teamMembersEmails[0])
                            row.HSC_LIST_FEE *= row.HSC_TEAM_MEMBER_2_PERCENT / 100;
                    }
    
                    state.rows.push(new HscPipelineFeesModel({ data: row, previousCumulative, location: this.props.location }));
                });
    
                state.rows.push(new HscPipelineFeesModel({
                    data: state.rows,
                    isTotal: true,
                    year,
                    location: this.props.location
                }));
            }
    
            state.totals.push(new HscPipelineFeesTotals({ data: state.rows, year, isCurrentYear: true, location: this.props.location }));
    
            for (let index = 1; index < res.length; index++) {
                const responseData = res[index].data.hscPipelineFees.data;
                if (responseData && Array.isArray(responseData)) {
                    responseData.forEach((row, i) => {
                        const previousCumulative = i > 0 ? responseData[i - 1].cumulative : 0;
    
                        if (teamMembersEmails.length < 2) {
                            if (row.HSC_TEAM_MEMBER_1 === teamMembersEmails[0])
                                row.HSC_LIST_FEE *= row.HSC_TEAM_MEMBER_1_PERCENT / 100;
                            else if (row.HSC_TEAM_MEMBER_2 === teamMembersEmails[0])
                                row.HSC_LIST_FEE *= row.HSC_TEAM_MEMBER_2_PERCENT / 100;
                        }
    
                        row.cumulative = row.HSC_LIST_FEE
                            ? parseFloat(row.HSC_LIST_FEE) + previousCumulative
                            : previousCumulative;
                    });
    
                    state.totals.push(new HscPipelineFeesTotals({
                        data: responseData,
                        year: --year,
                        location: this.props.location
                    }));
                }
            }
    
            state.totals.push(new HscPipelineFeesTotals({
                data: state.totals,
                isTotal: true,
                location: this.props.location
            }));
    
            this.setState(state);
        });
    }

    render() {
        const {rows, totals, loading, title, teamMembers,length} = this.state;

        return (
            <ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
					}
					return (
            <div className='HscPipelineFees'>
                <div className='title-row'>
                    <div className="Pipeline_head_left">
                        <h3 className='h3'>{title} </h3>
                        <h4 className='h3'>Transactions : {`${length ? length+0 : 0}`}</h4>
                        <h4 className='h3'>Loan Amount : {totals && totals.length && dollars(totals[0].loanAmount)}</h4>
                    </div>
                     <div className='Pipeline_head_right'>
                            <Dropdown
                                dropdownType='multiple'
                                optionsType='team-members'
                                optionLabelKey='NAME'
                                optionKey='EMAIL'
                                value={this.state.hscquery.HSC_TEAM_MEMBERS}
                                label='Agent'
                                valueKey='HSC_TEAM_MEMBERS'
                                data={this.state.hscquery}
                                handleParentChange={this.handleChangeDropdown}
                            />  
                        </div>
                </div>
                {
                    loading ?
                        <div className='loading'>Loading data...</div>
                        :
                        <div className={`${teamMembers ? 'with-agent':''}`}>
                            <PipelineTable rows={rows} columns={columns} hasTotalRow={true} className='list' />
                            {title != "Total Closed" && <PipelineTable rows={totals} columns={totalColumns} hasTotalRow={true} className='totals' />}
                        </div>
                }
            </div>
            	)
            }}

        </ApolloConsumer>
        );
    }
}